/**
 * LoadingState — single source of "data is loading" UX for every
 * panel. Replaces the four ad-hoc `<div className="loading">…</div>`
 * literals that previously lived inside StatsOverview, SignalTable,
 * AttributionPanel, and RegimeValidationPanel.
 *
 * Keep it deliberately dumb: no spinner animation, no timeouts —
 * it's a presentational primitive. Anything fancier (e.g. a delayed
 * spinner that only renders after 200 ms) can be layered on later
 * without touching every consumer.
 */
interface LoadingStateProps {
  /** Optional contextual label, e.g. "stats" or "regime panel". */
  label?: string;
  /**
   * If true, the block stretches full-width (used by panels that
   * own the whole row). Defaults to `false` for inline use inside
   * a card.
   */
  block?: boolean;
}

export function LoadingState({ label, block = false }: LoadingStateProps) {
  const text = label ? `Loading ${label}…` : "Loading…";
  return (
    <div
      className={`state-block state-block--loading${block ? " state-block--block" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="state-block-message">{text}</span>
    </div>
  );
}
